<script>
import {formatTime} from '../../../utils'
export default {
  name: 'EQuantity',
  props: ['stableData'],
  data () {
    return {
      // startDt: '2022/06/07 00:00:00',
      nowDt: '2022/06/08 00:00:00',
      runTime: {}
    }
  },
  computed: {
    w_level () {
      if (this.stableData && this.stableData.ea_kwh > 1000 && this.stableData.eb_kwh > 1000 && this.stableData.ec_kwh > 1000) {
        return true
      } else {
        return false
      }
    },
    var_level () {
      if (this.stableData && this.stableData.ea_kvarh > 1000 && this.stableData.eb_kvarh > 1000 && this.stableData.ec_kvarh > 1000) {
        return true
      } else {
        return false
      }
    },
    va_level () {
      if (this.stableData && this.stableData.ea_kvah > 1000 && this.stableData.eb_kvah > 1000 && this.stableData.ec_kvah > 1000) {
        return true
      } else {
        return false
      }
    },
    startDt () {
      console.log((this.stableData.start_time) * 1000)
      console.log(this.stableData.start_time)
      return (this.stableData.start_time) * 1000
    }
  },
  mounted () {
    this.timeFn()
  },
  methods: {
    formatTime,
    timeFn () {
      this.timing = setInterval(() => {
        this.nowDt = formatTime(new Date(), 'yyyy/MM/dd HH:mm:ss')
        var second = Math.floor(new Date(new Date(this.nowDt).getTime() - this.startDt) / 1000)
        // 天数
        var day = Math.floor(second / 3600 / 24)
        // 小时
        var hr = Math.floor(second / 3600 % 24)
        // 分钟
        var min = Math.floor(second / 60 % 60)
        // 秒
        var sec = Math.floor(second % 60)
        this.runTime = {
          day,
          hr,
          min,
          sec
        }
      }, 1000)
    }
  }
}
</script>

<template>
  <div class="pg">
    <!--      电度计量-->
    <div class="dataItems">
      <div class="title">电度计量</div>
      <div style="display: flex; justify-content: space-between; flex-wrap: wrap">
        <div style="width: 100%; display: flex; flex-wrap: wrap; height: 30px; line-height: 30px; color: #707070">
          <div style="width: 40%">
            <div
              style="width: 100%; display: flex; align-items: center; margin-left: 20px">
              <div>起始时间</div>
              <div style="margin-left: 20px">{{ formatTime(startDt, 'yyyy/MM/dd HH:mm:ss') }}</div>
            </div>
          </div>
          <div style="width: 45%">
            <div
              style="width: 100%; display: flex; align-items: center; margin-left: 20px;">
              <div>当前时间</div>
              <div style="margin-left: 20px">{{ nowDt }}</div>
            </div>
          </div>
<!--          <el-button type="primary" style="margin-left: 30px; margin-right: 30px; font-size: 20px;">重置</el-button>-->
        </div>
        <div
          style="width: 100%; display: flex; flex-wrap: wrap; justify-content: space-between; margin-top: 10px; color: #707070">
          <!--          <div style="width: 50%">-->
          <div
            style="width: 40%; display: flex; align-items: center; margin-left: 20px;">
            <div>运行时间</div>
            <div style="margin-left: 20px">{{ runTime.day }}天{{ runTime.hr }}时{{ runTime.min }}分{{ runTime.sec }}秒</div>
          </div>
          <!--          </div>-->
          <!--          <div style="width: 50%">-->
          <!--          </div>-->
        </div>
      </div>
      <div class="dataItem" style="margin-top: 10px; border-top: 1px solid black">
        <div class="dataName">
          <div class="dataTitle">电度</div>
          <div class="dataNvItem">P{{ w_level ? '(MWh)':'(kWh)' }}</div>
          <div class="dataNvItem">Q{{ var_level ? '(MVarh)':'(kVarh)' }}</div>
          <div class="dataNvItem">S{{ va_level ? '(MVAh)':'(kVAh)' }}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">A相</div>
          <div class="dataNvItem">{{ Number(stableData ? (w_level ? stableData.ea_kwh/1000 : stableData.ea_kwh) : 0).toFixed(w_level?2:0) }}</div>
          <div class="dataNvItem">{{ Number(stableData ? (var_level > 1000 ? stableData.ea_kvarh/1000 : stableData.ea_kvarh) : 0).toFixed(var_level?2:0) }}</div>
          <div class="dataNvItem">{{ Number(stableData ? (va_level > 1000 ? stableData.ea_kvah/1000 : stableData.ea_kvah) : 0).toFixed(va_level?2:0) }}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">B相</div>
          <div class="dataNvItem">{{ Number(stableData ? (w_level ? stableData.eb_kwh/1000 : stableData.eb_kwh) : 0).toFixed(w_level?2:0) }}</div>
          <div class="dataNvItem">{{ Number(stableData ? (var_level ? stableData.eb_kvarh/1000 : stableData.eb_kvarh) : 0).toFixed(var_level?2:0) }}</div>
          <div class="dataNvItem">{{ Number(stableData ? (va_level ? stableData.eb_kvah/1000 : stableData.eb_kvah) : 0).toFixed(va_level?2:0) }}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">C相</div>
          <div class="dataNvItem">{{ Number(stableData ? (w_level ? stableData.ec_kwh/1000 : stableData.ec_kwh) : 0).toFixed(w_level?2:0) }}</div>
          <div class="dataNvItem">{{ Number(stableData ? (var_level ? stableData.ec_kvarh/1000 : stableData.ec_kvarh) : 0).toFixed(var_level?2:0) }}</div>
          <div class="dataNvItem">{{ Number(stableData ? (va_level ? stableData.ec_kvah/1000 : stableData.ec_kvah) : 0).toFixed(va_level?2:0) }}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">总</div>
          <div class="dataNvItem">{{ Number(stableData ? (w_level ? stableData.et_kwh/1000 : stableData.et_kwh) : 0).toFixed(w_level?2:0) }}</div>
          <div class="dataNvItem">{{ Number(stableData ? (var_level ? stableData.et_kvarh/1000 : stableData.et_kvarh) : 0).toFixed(var_level?2:0) }}</div>
          <div class="dataNvItem">{{ Number(stableData ? (va_level ? stableData.et_kvah/1000 : stableData.et_kvah) : 0).toFixed(va_level?2:0) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";

.dataValue {
  width: 20%;
}

.dataItem {
  height: calc(100% - 130px);
}

.dataNvItem {
  height: calc((100% - 70px) / 3);
}
</style>



// WEBPACK FOOTER //
// src/pages/Stable/EQuantity/EQuantity.vue